<template>
  <el-select
    v-model="selectValue"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    :filterable="filterable"
    @change="handleChange"
    @clear="handleClear"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :disabled="item.disabled"
    />
  </el-select>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted } from 'vue'
import { e_SelectEnum } from '@/utils/publicEnum'

/**
 * 使用示例
 *  {
    label: '订单状态',
    field: 'status',
    component: 'SelectStatus',
    componentProps: {
      dictType: 'StatusEnum' // 字典类型
    }
  }
 * */

interface Props {
  modelValue?: string | number
  dictType: string
  placeholder?: string
  clearable?: boolean
  disabled?: boolean
  filterable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  placeholder: '请选择',
  clearable: true,
  disabled: false,
  filterable: true
})

const emit = defineEmits<{
  'update:modelValue': [value: string | number | undefined]
  change: [value: string | number | undefined, option: any]
}>()

const selectValue = ref<string | number | undefined>(props.modelValue)
const options = ref<Array<{ label: string; value: string | number; disabled?: boolean }>>([])

const handleChange = (value: string | number | undefined) => {
  emit('update:modelValue', value)
  const option = options.value.find((item) => item.value === value)
  emit('change', value, option)
}

const handleClear = () => {
  emit('update:modelValue', undefined)
  emit('change', undefined, undefined)
}

const fetchDictData = async () => {
  if (props.dictType) {
    const data = await e_SelectEnum(props.dictType)
    console.log('当前请求回来的状态', data)
    options.value = data
  }
}

watch(
  () => props.modelValue,
  (newVal) => {
    selectValue.value = newVal
  }
)

watch(
  () => props.dictType,
  () => {
    fetchDictData()
  },
  { immediate: true }
)

onMounted(() => {
  selectValue.value = props.modelValue
})
</script>

<style scoped></style>
